module.exports = __webpack_public_path__ + "img/scene_forest_big@2x.57707254.png";